import { AxiosResponse } from 'axios';
import HttpClientWithRetry from '../../../../http/client/HttpClientWithRetry';
import { CreateQuestionnaireTemplateResponse } from '../questionnaireTemplate.types';

export class QuestionnaireTemplateController {
  constructor(private readonly httpClient: HttpClientWithRetry) {}

  createTemplate(accountId: string, payload: any): Promise<AxiosResponse<CreateQuestionnaireTemplateResponse>> {
    const path = `/api/v1/account/${accountId}/question-templates`;
    // eslint-disable-next-line
    return this.httpClient.post<any>(path, payload);
  }

  updateTemplate(accountId: string, templateId: string, payload: any): Promise<AxiosResponse<any>> {
    const path = `/api/v1/account/${accountId}/question-templates/${templateId}`;
    return this.httpClient.put<any>(path, payload);
  }

  getTemplateById(accountId: string, templateId: string): Promise<AxiosResponse<any>> {
    const path = `/api/v1/account/${accountId}/question-templates/${templateId}`;
    return this.httpClient.get<any>(path);
  }

  validateDuplicateName(accountId: string, name: string): Promise<AxiosResponse<{ suggestedName: string }>> {
    const encoded = encodeURIComponent(name);
    return this.httpClient.get(`/api/v1/account/${accountId}/question-templates/validateDuplicateName?name=${encoded}`);
  }
}
